import type { Editor } from '@ckeditor/ckeditor5-core';
import GFMDataProcessor from '@ckeditor/ckeditor5-markdown-gfm/src/gfmdataprocessor';

export default class MarkdownToModelFragment {
  private _editor: Editor;
  private _processor: GFMDataProcessor;

  constructor(editor: Editor) {
    this._editor = editor;
    this._processor = new GFMDataProcessor(editor.data.viewDocument);
  }

  public toModel(text: string) {
    const viewFragment = this._processor.toView(text);

    return this._editor.data.toModel(viewFragment);
  }
}
